import React, { useState } from "react";

const FLAG_BASE_URL = "https://flagcdn.com";

function CountryFlag({ code, label, className = "" }) {
  const [failed, setFailed] = useState(false);
  const normalizedCode = code ? String(code).toLowerCase() : "";

  if (!normalizedCode) {
    return <span className={className}>-</span>;
  }

  if (failed) {
    return (
      <span className={className} title={label || code} aria-label={label || code}>
        {String(code).toUpperCase()}
      </span>
    );
  }

  return (
    <img
      className={className}
      src={`${FLAG_BASE_URL}/w40/${normalizedCode}.png`}
      srcSet={`${FLAG_BASE_URL}/w80/${normalizedCode}.png 2x`}
      alt={label || `${String(code).toUpperCase()} flag`}
      title={label || `${String(code).toUpperCase()} flag`}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}

export default CountryFlag;
